import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText, Badge, Box, Chip } from '@mui/material';
import propTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import styles from 'styles/common/layout.module.scss';
import { useGlobalContext } from 'context/GlobalContext';

function SidebarItem({ icon, text, path, count = 0, badgeLabel }) {
  const location = useLocation();
  const navigate = useNavigate;
  const { setShowModal, selectedProject, setNextPath } = useGlobalContext();

  // Check if current path matches the sidebar item path
  // For root path "/", only match exactly
  // For other paths, match if current path starts with the item path
  const isActive = path === '/'
    ? location.pathname === '/'
    : location.pathname.startsWith(path);

  const isInProgressTask = selectedProject?.some(task => task.status === 'waiting_on_client');

  const handleClick = e => {
    if (selectedProject.length > 0 && isInProgressTask) {
      e.preventDefault();
      if (isInProgressTask) {
        setNextPath(path);
        setShowModal(true);
      }
    } else {
      navigate(path);
    }
  };

  return (
    <ListItemButton
      component={Link}
      to={!isInProgressTask ? path : undefined}
      selected={!!isActive}
      onClick={isInProgressTask ? handleClick : undefined}
      sx={{
        transition: 'all .35s ease',
        backgroundColor: isActive ? 'rgba(255, 255, 255, 0.15) !important' : 'transparent',
        '&:hover': { backgroundColor: isActive ? '' : 'rgba(255, 255, 255, 0.02) !important' },
      }}
    >
      <ListItemIcon sx={{ minWidth: '40px', color: 'white' }} className={styles.listItemIcon}>
        <Badge badgeContent={count} color="primary">
          {icon}
        </Badge>
      </ListItemIcon>

      <ListItemText
        className="d-none d-md-block"
        primary={(
          <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
            {text}
            {badgeLabel && (
              <Chip
                label={badgeLabel}
                color="warning"
                size="small"
                sx={{
                  fontSize: 10,
                  height: 18,
                  fontWeight: 400,
                  px: 0.35,
                  fontFamily: 'Poppins, sans-serif',
                  color: '#fff',
                  marginRight: -0.5,
                }}
              />
            )}
          </Box>
        )}
      />
    </ListItemButton>
  );
}

SidebarItem.propTypes = {
  icon: propTypes.element.isRequired,
  text: propTypes.string.isRequired,
  path: propTypes.string.isRequired,
  count: propTypes.number,
  badgeLabel: propTypes.string,
};

export default SidebarItem;
